import { CanMatchFn, Route, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ProfileResolver } from '@app/resolvers/profile.resolver';

export const PermissionGuard: CanMatchFn = (route: Route) => {
  const router = inject(Router);
  const profileResolver = inject(ProfileResolver);

  const requiredPermission = route.data?.['permission'];

  const profile = profileResolver.getProfile();

  const hasPermission = profile?.web_app_menu_permissions?.some(
    (permission: any) => permission.name === requiredPermission
  );

  return hasPermission ? true : router.createUrlTree(['/404']);
};